import './_images';
import './_fonts';
import '../styles/app.scss';

import { CustomBtnTestimonialSlider } from './components/CustomBtnTestimonialSlider';
import { HomeTestimonialsComponent } from './components/HomeTestimonialsComponent';
import { SecureAuthComponent } from './components/SecureAuthComponent';
import { CodeSamplesComponent } from './components/CodeSamplesComponent';
import { ProductBoxesComponent } from './components/ProductBoxesComponent';
import { VideoBoxesComponent } from './components/VideoBoxesComponent';
import { TrustedBoxesComponent } from './components/TrustedBoxesComponent';
import { CertificationsComponent } from './components/CertificationsComponent';
import { LocationBoxesComponent } from './components/LocationBoxesComponent';
import { PostArchiveComponent } from './components/PostArchiveComponent';
import { MediaArchiveComponent } from './components/MediaArchiveComponent';
import { CaseStudyArchiveComponent } from './components/CaseStudyArchiveComponent';
import { ContentHubArchiveComponent } from './components/ContentHubArchiveComponent';
import { TableContentComponent } from './components/TableContentComponent';
import { ProductAdvantagesComponent } from './components/ProductAdvantagesComponent';
import { StickyHeaderComponent } from './components/StickyHeaderComponent';
import { MediaPostsComponent } from './components/MediaPostsComponent';
import { EventArchiveComponent } from './components/EventArchiveComponent';
import { WhyBoxesComponent } from './components/WhyBoxesComponent';
import { ImplementationBoxesComponent } from './components/ImplementationBoxesComponent';
import { DeveloperPageComponent } from './components/DeveloperPageComponent';
import { ServiceBoxesComponent } from './components/ServiceBoxesComponent';
import { AnnouncementComponent } from './components/AnnouncementComponent';
import { BindIdAnimationComponent } from './components/BindIdAnimationComponent';
import { BindIdCardsComponent } from './components/BindIdCardsComponent';
import { BindIdCarouselComponent } from './components/BindIdCarouselComponent';
import { BindIdSolidComponent } from './components/BindIdSolidComponent';
import { ExperienceEmbedComponent } from './components/ExperienceEmbedComponent';
import { PartnersComponent } from './components/PartnersComponent';
import { CertificationsHomeComponent } from './components/CertificationsHomeComponent';
import { HsfRedirectComponent } from './components/HsfRedirectComponent';
import { RelatedReadingComponent } from './components/RelatedReadingComponent';
import { GaElementModifierComponent } from './components/GaElementModifierComponent';
import { HsMiscComponent } from './components/HsMiscComponent';
import { IdentityHubComponent } from './components/IdentityHubComponent';
import { UtmComponent } from './components/UtmComponent';
import { EventSessionFeedComponent } from './components/EventSessionFeedComponent';
import { EventSingleComponent } from './components/EventSingleComponent';
import { VideoCarouselComponent } from './components/VideoCarouselComponent';
import { ResourcesGridComponent } from './components/ResourcesGridComponent';
import { HsAnalyticsComponent } from './components/HsAnalyticsComponent';
import { ElementorMobileCarouselComponent } from './components/ElementorMobileCarouselComponent';
import { ElementorCarouselComponent } from './components/ElementorCarouselComponent';
import {
	elementorMobileDefault as elementorMobileCarouselConfig,
	passwordlessCounter as passwordlessCounterConfig,
	passwordlessVideoCarousel as passwordlessVideoCarouselConfig,
} from './configs/Swiper';
import { GoodbyePasswordsPageComponent } from './components/GoodbyePasswordsPageComponent';
import { ElementorLottieComponent } from './components/ElementorLottieComponent';
import { IdentityLifecycleComponent } from './components/IdentityLifecycleComponent';
import { EventOptionAnimation } from './components/EventOptionAnimation';
import LogoCarousel from './components/LogoCarousel';
import SubscribePopup from './components/SubscribePopup';
import RequestDemoButtons from './components/RequestDemoButtons';
import TestimonialsCarousel from "./components/TestimonialsCarousel";

document.addEventListener(
	'DOMContentLoaded',
	() => {
		
		const testimonialSlider = new CustomBtnTestimonialSlider();
testimonialSlider.initialize();
		const homeTestimonialsComponent = new HomeTestimonialsComponent();
homeTestimonialsComponent.initialize();
		const secureAuthComponent = new SecureAuthComponent();
		const codeSamplesComponent = new CodeSamplesComponent();
		const productBoxesComponent = new ProductBoxesComponent();
		const videoBoxesComponent = new VideoBoxesComponent();
		const trustedBoxesComponent = new TrustedBoxesComponent();
		const certificationsComponent = new CertificationsComponent();
		const locationBoxesComponent = new LocationBoxesComponent();
		const postArchiveComponent = new PostArchiveComponent();
		const mediaArchiveComponent = new MediaArchiveComponent();
		const caseStudyArchiveComponent = new CaseStudyArchiveComponent();
		const contentHubArchiveComponent = new ContentHubArchiveComponent();
		const tableContentComponent = new TableContentComponent();
		const productAdvantagesComponent = new ProductAdvantagesComponent();
		const stickyHeaderComponent = new StickyHeaderComponent();
		stickyHeaderComponent.initialize();
		const mediaPostsComponent = new MediaPostsComponent();
		const eventArchiveComponent = new EventArchiveComponent();
		const subscribePopup = new SubscribePopup();
		const requestDemoButtons = new RequestDemoButtons();
		const whyBoxesComponent = new WhyBoxesComponent();
		const implementationBoxesComponent = new ImplementationBoxesComponent();
		const developerPageComponent = new DeveloperPageComponent();
		const serviceBoxesComponent = new ServiceBoxesComponent();
		const announcementComponent = new AnnouncementComponent();
		const bindIdAnimationComponent = new BindIdAnimationComponent();
		const bindIdCardsComponent = new BindIdCardsComponent();
		const bindIdCarouselComponent = new BindIdCarouselComponent();
		const bindIdSolidComponent = new BindIdSolidComponent();
		const experienceEmbedComponent = new ExperienceEmbedComponent();
		const partnersComponent = new PartnersComponent();
		const certificationsHomeComponent = new CertificationsHomeComponent();
		const hsfRedirectComponent = new HsfRedirectComponent();
		const relatedReadingComponent = new RelatedReadingComponent();
		const gaElementModifierComponent = new GaElementModifierComponent();
		gaElementModifierComponent.initialize();
		const hsMiscComponent = new HsMiscComponent();
		hsMiscComponent.initialize();
		const identityHubComponent = new IdentityHubComponent();
		identityHubComponent.initialize();
		const utmComponent = new UtmComponent();
		utmComponent.initialize();
		const eventSessionFeedComponent = new EventSessionFeedComponent();
		eventSessionFeedComponent.initialize();
		const eventSingleComponent = new EventSingleComponent();
		eventSingleComponent.initialize();
		const videoCarouselComponent = new VideoCarouselComponent();
		videoCarouselComponent.initialize();
		const resourcesGridComponent = new ResourcesGridComponent();
		resourcesGridComponent.initialize();
		const hsAnalyticsComponent = new HsAnalyticsComponent();
		hsAnalyticsComponent.initialize();
		const passwordlessMovementComponent =
			new ElementorMobileCarouselComponent(
				'.passwordless-movement-section',
				passwordlessCounterConfig
			);
		passwordlessMovementComponent.initialize();
		const passwordlessCounterComponent =
			new ElementorMobileCarouselComponent(
				'.passwordless-counter-section',
				passwordlessCounterConfig
			);
		passwordlessCounterComponent.initialize();
		const passwordlessVideoCarouselComponent =
			new ElementorCarouselComponent(
				'.passwordless-video-carousel',
				passwordlessVideoCarouselConfig
			);
		passwordlessVideoCarouselComponent.initialize();
		const goodbyePasswordsPageComponent =
			new GoodbyePasswordsPageComponent();
		goodbyePasswordsPageComponent.initialize();
		const elementorLottieComponent = new ElementorLottieComponent(
			'.passwordless-video-carousel'
		);
		elementorLottieComponent.initialize();
		const identityLifecycleComponent = new IdentityLifecycleComponent();
		identityLifecycleComponent.initialize();
		const eventOptionAnimation = new EventOptionAnimation();
		eventOptionAnimation.init();
		const logoCarousel = new LogoCarousel();
		logoCarousel.init();
		const testimonialsCarousel = new TestimonialsCarousel();
	},
	false
);
